/**
 * ParkingPayment API
 *
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type PaymentGatewayProvider = 0;

export const PaymentGatewayProvider = {

    NUMBER_0: 0 as PaymentGatewayProvider
};

